<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12>
				<app-datatable
					:title="$t('title.coupon_datatable')"
					:endpoint="endpoint"
					:data="data"
					:headers="headers"
					:filter="filter"
					@onEdit="editItem"
					@onDelete="deleteItem"
					@onView="viewItem"
				>
					<template v-slot:[`item.image`]="{ item }">
						<app-thumbnail-placeholder
							v-model="item.image"
						></app-thumbnail-placeholder>
					</template>
					<template v-slot:[`item.credit`]="{ item }">
						{{ item.credit }} pts
					</template>
					<template v-slot:[`item.price`]="{ item }">
						{{ item.price | currency }}
					</template>
					<template v-slot:[`item.active`]="{ item }">
						<app-active-button
							v-model="item.active"
						></app-active-button>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>
		<app-create-fab-button
			@click="$inertia.visit($route('central.coupons.create'))"
		></app-create-fab-button>

		<app-delete-dialog
			ref="deleteDialog"
			:endpoint="'central.coupons.destroy'"
			:uuid="item.uuid"
		></app-delete-dialog>
	</v-container>
</template>

<script>
export default {
	props: ["data"],
	data() {
		return {
			filter: {},
			item: {},
		};
	},
	computed: {
		endpoint() {
			return this.$route("central.coupons.index");
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					width: 60,
					align: "left",
					sortable: false,
				},
				{
					text: this.$t("Image"),
					value: "image",
					align: "start",
					sortable: false,
					width: 50,
				},
				{
					text: this.$t("Name"),
					value: "name",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Price"),
					value: "price",
					sortable: false,
					searchable: false,
					width: 120,
				},
				{
					text: this.$t("Bonus"),
					value: "bonus",
					sortable: false,
					searchable: false,
					width: 120,
				},
				{
					text: this.$t("label.credit"),
					value: "credit",
					sortable: false,
					searchable: false,
					width: 120,
				},
				{
					text: this.$t("Active"),
					value: "active",
					sortable: false,
					searchable: false,
					align: "right",
					width: 80,
				},
			];
		},
	},

	methods: {
		onFilter() {
			//
		},

		editItem(item) {
			this.$inertia.get(this.$route("central.coupons.edit", item.uuid));
		},

		viewItem(item) {
			this.$inertia.get(this.$route("central.coupons.show", item.uuid));
		},
		deleteItem(item) {
			this.item = Object.assign({}, item);
			this.$refs.deleteDialog.open();
		},
	},
};
</script>